export default (state, tagList) => {
    state.tags = tagList
}
